import {defineMessages} from 'react-intl'

export default defineMessages({
    sharesTotalOne: {
        id: 'containers.VoicePage.stats.sharesTotal.one',
        defaultMessage: 'Shared one time',
    },
    sharesTotalOther: {
        id: 'containers.VoicePage.stats.sharesTotal.other',
        defaultMessage: 'Shared {count} times',
    },
    jobsTotal: {
        id: 'containers.VoicePage.stats.jobsTotal',
        defaultMessage: '{count} completed jobs',
    },
    minutesTotal: {
        id: 'containers.VoicePage.stats.minutesTotal',
        defaultMessage: '{count} minutes recorded',
    },
    studio: {
        id: 'containers.VoicePage.studio',
        defaultMessage: 'Studio equipment',
    },
    nativeIn: {
        id: 'containers.VoicePage.nativeIn',
        defaultMessage: '{age} years old {gender}, native {languages} speaker{hasSkills, select, true { offering {skills} services.} other {.}}',
    },
    additionalLanguages: {
        id: 'containers.VoicePage.additionalLanguages',
        defaultMessage: 'Additional languages: {languages}',
    },
    reviews: {
        id: 'containers.VoicePage.reviews',
        defaultMessage: 'Reviews',
    },
    experience: {
        id: 'containers.VoicePage.experience',
        defaultMessage: 'My previous experience',
    },
    services: {
        id: 'containers.VoicePage.services',
        defaultMessage: 'Profile',
    },
    joinedOn: {
        id: 'containers.VoicePage.joinedOn',
        defaultMessage: 'Joined in',
    },
    listenTo: {
        id: 'containers.VoicePage.skills.listenTo',
        defaultMessage: 'Listen to {sku}',
    },
    demosKeyboardShortcuts: {
        id: 'containers.VoicePage.skills.demosKeyboardShortcuts',
        defaultMessage: 'Play, pause and navigate demos',
    },
    selectKeyboardShortcut: {
        id: 'containers.VoicePage.skills.selectKeyboardShortcut',
        defaultMessage: 'Select voice or demo',
    },
    goBack: {
        id: 'containers.VoicePage.skills.goBack',
        defaultMessage: 'Explore more voices',
    },
    skills: {
        id: 'containers.VoicePage.skills',
        defaultMessage: 'Skills',
    },
    acting: {
        id: 'containers.VoicePage.skills.acting',
        defaultMessage: 'Acting',
    },
    actingHint: {
        id: 'containers.VoicePage.skills.acting.hint',
        defaultMessage: 'Adding a voice to a cartoon character',
    },
    actingHref: {
        id: 'containers.VoicePage.skills.acting.href',
        defaultMessage: 'http://voicearchive.com/en/services',
    },
    live_session: {
        id: 'containers.VoicePage.skills.live_session',
        defaultMessage: 'Live Session',
    },
    live_sessionHint: {
        id: 'containers.VoicePage.skills.live_session.hint',
        defaultMessage:
            'I am available to be in direct contact during the recording of your voice over.',
    },
    live_sessionHref: {
        id: 'containers.VoicePage.skills.live_session.href',
        defaultMessage: 'http://voicearchive.com/en/services',
    },
    advanced_live_session: {
        id: 'containers.VoicePage.skills.advanced_live_session',
        defaultMessage: 'Advanced Live Session',
    },
    advanced_live_sessionHint: {
        id: 'containers.VoicePage.skills.advanced_live_session.hint',
        defaultMessage:
            'I am available to be in direct contact during the recording of your voice over.',
    },
    advanced_live_sessionHref: {
        id: 'containers.VoicePage.skills.advanced_live_session.href',
        defaultMessage: 'http://voicearchive.com/en/services',
    },
    shareInstructions: {
        id: 'components.VoicePage.shareInstructions',
        defaultMessage: 'Copy the link to share this voice profile',
    },
    share: {
        id: 'components.VoicePage.share',
        defaultMessage: 'Share',
    },
    copiedToClipboard: {
        id: 'components.VoicePage.copiedToClipboard',
        defaultMessage: 'Copied link',
    },
    customDemoOfferTitle: {
        id: 'components.VoicePage.customDemoOfferTitle',
        defaultMessage:
            'Get a <b>free</b> demo from {sku}',
    },
    customDemoOfferBody: {
        id: 'components.VoicePage.customDemoOfferBody',
        defaultMessage:
            'In fact, you can get a custom demo, free of charge, from any of our recommended voice talents by visiting their profile and make a request.',
    },
    experienceWithBrands: {
        id: 'components.VoicePage.experienceWithBrands',
        defaultMessage: 'I have worked with brands like {brands}.',
    },
    missingDemoProduct: {
        id: 'components.VoicePage.missingDemoProduct',
        defaultMessage: 'Demo',
    },
    custom: {
        id: 'components.VoicePage.custom',
        defaultMessage: 'Custom'
    },
    download: {
        id: 'components.VoicePage.download',
        defaultMessage: 'Download'
    },
    deselect: {
        id: 'components.VoicePage.deselect',
        defaultMessage: 'Deselect'
    },
    select: {
        id: 'components.VoicePage.select',
        defaultMessage: 'Select'
    },
    demoAmountForVoicetalent:{
        id: 'components.VoicePage.demoAmountForVoicetalent',
        defaultMessage: '{amount} demos'
    },
    tryvoice: {
        id: 'components.VoicePage.tryvoice',
        defaultMessage: 'Try AI voice'
    },
    demoVoiceLabel: {
        id: 'components.VoicePage.demoVoiceLabel',
        defaultMessage: 'Original Voice Demo'
    },
    syntheticVoiceLabel: {
        id: 'components.VoicePage.syntheticVoiceLabel',
        defaultMessage: 'AI Generated Demo'
    },
    dialect: {
        id: 'components.VoicePage.dialect',
        defaultMessage: 'Dialect'
    },
    accent: {
        id: 'components.VoicePage.accent',
        defaultMessage: 'Accent'
    },
})
